import React from "react";
import LinearProgress from '@material-ui/core/LinearProgress';
import { withRouter } from "../../_helpers";

// TODO: Should be rewrited to pure function
class AnimateLoading extends React.Component {
  animateTimeout;
  stopAnimateTimeout;
  state = {
    width: 0,
    routeChanged: false
  };

  componentDidUpdate(nextProps) {
    if (this.props.location?.pathname !== nextProps.location?.pathname) {
      this.animate();
      // toggle offcanvas
      if (document.body.classList.contains('offcanvas')) document.getElementsByClassName('js-martin-nav-toggle')[0].click();
      // scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  animate() {
    this.animateTimeout = setTimeout(() => {
      if (this.state.width <= 100) {
        this.setState({ width: this.state.width + 10 });
        this.animate();
      } else {
        this.stopAnimate();
      }
    }, 30);
  }
  stopAnimate() {
    clearTimeout(this.animateInterval);
    this.stopAnimateTimeout = setTimeout(() => {
      this.setState({ width: 0 });
    }, 300);
  }
  componentWillUnmount() {
    if (this.stopAnimateTimeout) {
      clearTimeout(this.stopAnimateTimeout);
    }
    if (this.animateTimeout) {
      clearTimeout(this.animateTimeout);
    }
  }
  render() {
    return (<>
      {this.state.width > 0 && (
        <div style={{ height: "100%", width: "100%", position: 'fixed', zIndex: '100000', top: '0', backgroundColor: 'rgba(255, 255, 255, .3)', transition: 'all .3s ease' }}>
          <LinearProgress variant="determinate" color="secondary" value={this.state.width} style={{ height: "3px", top: "0" }} />
        </div>
      )}
    </>);
  }
}

export default withRouter(AnimateLoading);
